import React, {useEffect} from 'react';
import ActionItemDropdownPriorities from './ActionItemDropdownPriorities.mjs';
import FilePicker from './FilePicker.mjs';
import { useCTAL } from './CTAL_Hooks.js';

export default function ActionItemDropdownFormShortList({sel_action_item, action}) 
{
    const { app_user, action_item, setSelectedActionItem, setActionItemDisplayRefresh } = useCTAL();
    
    useEffect(() =>
    {
        if ((!sel_action_item) || (!app_user)) return;
        
        //Only show Delete Action if current app_user is the creator of the Action OR App User is a Team Admin, else hide
        var display_txt = "none";
        if (sel_action_item.CreatedBy == app_user.UserFullName) display_txt = "block";
        
        if (sel_action_item.AssignStatus != "Pending-Assignment") {
            document.getElementById(sel_action_item.Name+"-divider").style.display = display_txt;
            document.getElementById(sel_action_item.Name+"-delete").style.display = display_txt;
        }
    }, [sel_action_item]);

    const reject_action_item = () => { 
        var reason = document.getElementById("reject-reason-select");
        action("reject_action_item_assignment", reason.value)
        reason.value = "";
    }

    if (sel_action_item.AssignStatus == "Pending-Assignment") {
        return (
            <div class="dropdown-menu">
                <form class="px-2 py-1">
                    <div class="row ">
                        <div class="col-1 ms-2">
                            <button type="button" class="btn btn-sm btn-outline-secondary" onClick={ () => action("accept_action_item_assignment") }>Accept</button>
                        </div>
                    </div>
                    <div class="row mt-1 me-2">
                        <div class="col ms-2">
                            <div class="input-group input-group-sm ">
                            <button class="btn btn-outline-secondary" type="button" onClick={ () => reject_action_item() }>Reject</button>
                            <select class="form-select" id="reject-reason-select" aria-label="Example select with button addon">
                                <option selected value="">Reason...</option>
                                <option>Too many Assigned Action-Items</option>
                                <option>Out of the Office</option>
                                <option>Does not match skillset</option>
                                <option>Other</option>
                            </select>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    const refresh_action_item = () => { 
        //Only Refresh Action Item if it's already selected
        if ((action_item != undefined) && (action_item.Name == sel_action_item.Name)) {
            setSelectedActionItem(action_item); //Keep this Action Item Detail Displayed
            setActionItemDisplayRefresh(true);  //Trigger the Action-Item bulk download in ActionItem.mjs     
        }
    }

    const AddComment = () => { 
        var comment = document.getElementById(sel_action_item.ActionItemID);
        action("create_comment", comment.value)
        comment.value = "";
    }

    var release_text = "Move to Private Long List";
    if (!sel_action_item.IsPrivate)
        release_text = `Move back to Team List`;
        
    const picker_prefix = "ShortList";

    return (
        <div class="dropdown-menu"  >
            <a class="dropdown-item" href="#" onClick={ () => action("close_action_item") }>Close Action</a>
            <a class="dropdown-item" href="#" onClick={ () => action("release_action_item") }>{release_text}</a>

            <form class="px-2 py-1">

                <div class="row">
                    <div class="col ms-2 mb-2">
                        <ActionItemDropdownPriorities action_item={sel_action_item} action={action} />
                    </div>
                </div>   

                <FilePicker home_team_id={sel_action_item.HomeTeamID} target_type={sel_action_item.Type} target_id={sel_action_item.ActionItemID} refresh_target = {refresh_action_item} picker_prefix={picker_prefix} /> 

                <div class="row mt-2">
                    <div class="col">
                        <div class="form-floating form-floating-sm mb-0">
                            <textarea id={sel_action_item.ActionItemID} class="form-control" placeholder="Add Comment"></textarea>
                            <label class="select-floating-label" htmlFor="floatingSelect">Add Comment</label>
                        </div>
                    </div>
                </div>   
                
                <div class="row">
                    <div class="col mt-1 text-end">
                        <button type="button" class="btn btn-sm btn-outline-secondary" onClick={ () => AddComment() }>Add</button>
                    </div>
                </div>   

            </form>
            <div id={sel_action_item.Name+"-divider"} class="dropdown-divider"></div>
            <a id={sel_action_item.Name+"-delete"} class="dropdown-item" href="#" onClick={ () => action("delete_action_item_ui") }>Delete Action</a>
        </div>
    );
}